import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../auth/useAuth';
import { useTheme } from '../contexts/ThemeContext';

export function Login() {
  const { user, isLoading, login } = useAuth();
  const { lightMode } = useTheme();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  // AuthCallback sends failed sign-ins back with ?error=…
  const authError = params.get('error') ? 'Sign-in failed. Use your @fivetran.com account and try again.' : '';

  useEffect(() => {
    if (!isLoading && user) navigate('/runs', { replace: true });
  }, [user, isLoading, navigate]);

  if (isLoading) {
    return (
      <div style={{ minHeight: '100dvh', background: 'var(--c-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ width: 32, height: 32, border: '3px solid var(--c-b4)', borderTopColor: 'var(--accent)', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
      </div>
    );
  }

  return (
    <main className="login">
      <div className="login-card">
        <img className="login-logo" src="/fivetran-logo.svg" alt="Fivetran" style={{ filter: lightMode ? 'invert(1)' : 'none' }} />
        <h1>AI exploratory dashboard</h1>
        <p className="login-sub">Sign in to continue</p>
        <button type="button" className="login-google" onClick={() => login('okta')}>
          <span
            aria-hidden
            style={{
              width: 18, height: 18, borderRadius: 4, display: 'inline-flex', alignItems: 'center',
              justifyContent: 'center', background: '#0073e6', color: '#fff', fontSize: 11, fontWeight: 800,
            }}
          >
            O
          </span>
          Continue with Okta
        </button>
        {authError && <div className="login-err" role="alert">{authError}</div>}
        <p className="login-note">Access restricted to @fivetran.com accounts</p>
    </div>
    </main>
  );
}
